import rpc from './core'

const urls = {
  personalities: {
    url: '/priests/personalities',
    method: 'GET'
  },
  currencies: {
    url: '/info/currencies',
    method: 'GET'
  }
}

const loadPersonalities = async (count = 3) => {
  return rpc({ params: { count }, ...urls['personalities'] })
}
const loadCurrencies = async () => {
  return rpc({ ...urls['currencies'] })
}

export default { loadPersonalities, loadCurrencies }
